import { Rule } from "antd/lib/form";
import DateRenderer from "components/DateRenderer";
import { Form } from "components/styleguide";
import DatePickerAvailableDaysWrapper from "components/styleguide/components/DatePickerAvailableDaysWrapper";
import { ForumAttendeeAvailabilityResponseModel } from "generated/api";
import { EventLayoutContext } from "layouts/EventLayout/types";
import { Moment } from "moment";
import React from "react";
import { useOutletContext } from "react-router-dom";
import { toWallClockMoment } from "utils/dateUtils";

import { columnDataIndexes } from ".";

export default function AvailabilityCell({
  disabledDate,
  editing,
  index,
  title,
  record,
  children,
  ...restProps
}: {
  disabledDate: (date: Moment) => boolean;
  editing: boolean;
  yupSync: Rule;
  index: string;
  title: string;
  type: string;
  record: ForumAttendeeAvailabilityResponseModel;
  children: React.ReactNode[];
}) {
  const isStartTime = index === columnDataIndexes.start;
  const isEndTime = index === columnDataIndexes.end;

  const { forum } = useOutletContext<EventLayoutContext>();

  if (editing) {
    if (isStartTime) {
      return (
        <td {...restProps} colSpan={2}>
          <Form.Item
            name="range"
            initialValue={[
              record?.unavailableFromDate ? toWallClockMoment(record.unavailableFromDate) : null,
              record?.unavailableToDate ? toWallClockMoment(record.unavailableToDate) : null,
            ]}
          >
            <DatePickerAvailableDaysWrapper.RangePickerAvailableDaysWrapper
              style={{ width: "100%" }}
              showTime={true}
              minuteStep={5}
              eventStartDate={toWallClockMoment(forum?.startDate)}
              eventEndDate={toWallClockMoment(forum?.endDate)}
              defaultPickerValue={
                record?.unavailableFromDate && record?.unavailableToDate
                  ? [toWallClockMoment(record.unavailableFromDate), toWallClockMoment(record.unavailableToDate)]
                  : undefined
              }
              availableDatesGetterType="ActualDays"
            />
          </Form.Item>
        </td>
      );
    } else if (isEndTime) {
      return <></>;
    }
  }

  return (
    <td {...restProps}>
      {(isStartTime || isEndTime) && children ? (
        <span>
          <DateRenderer date={children[1] as string} showTime wallClock />
        </span>
      ) : (
        children
      )}
    </td>
  );
}
